import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { SharedSettings } from '../models/shared-settings';
import { NormalizedUsAddress } from '../models/normalized-us-address';
import { url } from '../helpers/url';

@Injectable({
    providedIn: 'root'
})
export class AddressService {
    constructor(private http: HttpClient, private settings: SharedSettings) { }

    search(query: string): Observable<NormalizedUsAddress[]> {
        return this.http.get<NormalizedUsAddress[]>(
            this.settings.apiBaseUrl + url`address/search?q=${query}`
        );
    }
}
